import { Directive } from '@angular/core';

@Directive({
  selector: 'bixi-filter-actions, [bixi-filter-actions]',
  exportAs: 'bixiFilterActions',
  host: {
    class: 'bixi-filter-actions'
  }
})
export class BixiFilterActionsDirective { }
